/**
 * Users API Module
 * Central export point for user management functionality
 */

// === MAIN API FUNCTIONS ===
export * from './api';

// === AUTH UTILITIES ===
export {
  getAuthConfigFromStore,
  isAuthConfigured,
  isAuthConfigValid,
  getAuthHeaders
} from '../auth/authUtils';

// === TYPE EXPORTS ===
export type {
  InviteMemberParams,
  InviteMemberResponse,
  GetInviteMemberListParams,
  GetInviteMemberListResponse,
  DeleteMemberParams,
  DeleteMemberResponse,
  GetUserPermissionsParams,
  GetUserPermissionsResponse,
  GetTargetUserPermissionsParams,
  GetTargetUserPermissionsResponse,
  SetTargetUserPermissionsParams,
  SetTargetUserPermissionsResponse,
  UserPermissions,
  InvitedMemberInfo,
  InvitedMemberGroup,
  FleetUserType,
  LoginApp,
  TokenType
} from './types';

// === AUTH CONFIG TYPE ===
export type { AuthConfig } from '../auth/authUtils';

// === CONSTANTS ===
export {
  INVITE_MEMBER_ERROR_MESSAGES,
  GET_INVITE_MEMBER_ERROR_MESSAGES,
  DELETE_MEMBER_ERROR_MESSAGES,
  GET_USER_PERMISSIONS_ERROR_MESSAGES,
  GET_TARGET_USER_PERMISSIONS_ERROR_MESSAGES,
  SET_TARGET_USER_PERMISSIONS_ERROR_MESSAGES,
  FLEET_USER_TYPE_NAMES,
  LOGIN_APP_NAMES,
  MAIL_STATUS_NAMES,
  USER_ROLE_NAMES,
  PERMISSION_DISPLAY_NAMES,
  PERMISSION_CATEGORIES
} from './types';

// === VERSION INFO ===
export const USERS_API_VERSION = '1.0.0';
export const USERS_API_NAME = 'FleetA Users Management API';